/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {NavLink, useSearchParams} from 'react-router-dom';
import {Edit, FilterList as FilterListIcon} from '@mui/icons-material';
import {Grid, TableCell, TableRow, TableBody, IconButton} from '@mui/material';

import {USER_TYPE, USER_ROLE} from '../../constants/UserType';
import {path} from '../../routes/path';
import ModalAddNew from './components/ModalAddNew/ModalAddNew';
import {
  ColumnsType,
  RowType,
  typeRoutes,
} from '../../types/typeSDCAdministrators';
import {Table, Breadcrumbs, Tooltips, Button, Chip} from '../../components';
import AdministratorsService from '../../services/Administrators/administrators.service';
import useAuth from '../../hooks/useAuth';
import ExportExcelService from '../../services/ExportExcel/ExportExcel';
import {ColorType} from '../../types/typeChip';
import ModalFilter from './components/Modalfilter/ModalFilter';
import queryString from 'query-string';
import IslandPartnerService from '../../services/Islander/islander.service';

// style
import {
  StyledAction,
  Typography,
  Divider,
  StyledIcon,
  StyledStack,
} from './SDCAdministrators.style';
import success from '../../constants/success';
import {isEmpty} from 'lodash';
import {
  rbacDepartments,
  rbacPermissions,
} from '../../constants/roleBasedAccessControlConstants';
import {formatLocalDateFromUTCTime} from '../../utils';
import {USER_STATUS} from '../../constants/status';
import AccessRoleService from '../../services/AccessRoles/AccessRole.service';

function SDCAdministrators() {
  const formatDateTimes = 'DD/MM/YYYY HH:mm:ss';

  const {getUser, showNotification, checkRbac} = useAuth();
  const {email, accessRoleDepartments} = getUser() || {};
  const [searchParams, setSearchParams] = useSearchParams();
  // states
  const [order] = useState<'desc' | 'asc'>('asc');
  const [orderBy] = useState('');
  const [dense] = useState(false);
  const [focusId, setFocusId] = useState(null);
  const [isModalAddNew, setIsModalAddNew] = useState(false);
  const [dataSource, setDataSource] = useState<Array<RowType>>([]);
  const [totalPage, setTotalPage] = useState(0);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [isModalFilter, setIsModalFilter] = useState(false);
  const defaultValueFilter = {
    type_eq: searchParams.get('type_eq') ?? '',
    roleName_contains: searchParams.get('roleName_contains') ?? '',
    ipName_contains: searchParams.get('ipName_contains') ?? '',
    email_contains: searchParams.get('email_contains') ?? '',
    phoneNumber_contains: searchParams.get('phoneNumber_contains') ?? '',
    adminName_contains: searchParams.get('adminName_contains') ?? '',
    isFreeze_eq: searchParams.get('isFreeze_eq') ?? '',
  };
  const [valueFilter, setValueFilter] = useState(defaultValueFilter);
  const [merchants, setMerchants] = useState([]);
  const [adminRoles, setAdminRoles] = useState<any>([]);

  const [params, setParams] = useState({
    _page: 0,
    _size: 10,
    status_eq: 1,
    type_eq: searchParams.get('type_eq') ?? undefined,
    roleName_contains: searchParams.get('roleName_contains') ?? undefined,
    ipName_contains: searchParams.get('ipName_contains') ?? undefined,
    email_contains: searchParams.get('email_contains') ?? undefined,
    phoneNumber_contains: searchParams.get('phoneNumber_contains') ?? undefined,
    adminName_contains: searchParams.get('adminName_contains') ?? undefined,
    isFreeze_eq: searchParams.get('isFreeze_eq') ?? undefined,
  });

  const columns: Array<ColumnsType> = [
    {
      dataIndex: 'id',
      numeric: false,
      disablePadding: false,
      label: 'ID',
    },
    {
      dataIndex: '',
      numeric: false,
      disablePadding: false,
      label: 'Full name',
    },
    {
      dataIndex: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email',
    },
    {
      dataIndex: 'type',
      numeric: false,
      disablePadding: false,
      label: 'Type',
    },
    {
      dataIndex: 'islandPartnerName',
      numeric: false,
      disablePadding: false,
      label: 'Island Partner',
    },
    {
      dataIndex: 'role',
      numeric: false,
      disablePadding: false,
      label: 'Role',
    },
    {
      dataIndex: 'lastLogin',
      numeric: false,
      disablePadding: false,
      label: 'Last login',
    },
    {
      dataIndex: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Status',
    },
    {
      dataIndex: null,
      numeric: false,
      disablePadding: false,
      label: '',
    },
  ];

  const onChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setParams(preState => ({
      ...preState,
      _page: newPage,
    }));
  };

  const onChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setParams(preState => ({
      ...preState,
      _page: 0,
      _size: parseInt(event.target.value, 10),
    }));
  };

  const renderAction = (value: string) => {
    if (
      !checkRbac({
        permissionString: [
          rbacPermissions.ADMINISTRATORS__LISTING__VIEW,
          rbacPermissions.ADMINISTRATORS__LISTING__EDIT_ADMINISTRATORS,
          rbacPermissions.ADMINISTRATORS__LISTING__EDIT_MERCHANTS,
        ],
      })
    ) {
      return;
    }
    if (focusId === value) {
      return (
        <StyledAction>
          <Tooltips title="Edit">
            <IconButton
              aria-label="details"
              component={NavLink}
              to={`/${path.PORTAL_USERS}/${value}`}
              size="medium"
            >
              <Edit style={StyledIcon} />
            </IconButton>
          </Tooltips>
        </StyledAction>
      );
    }
  };

  const toggleModal = () => {
    setIsModalAddNew(!isModalAddNew);
  };

  const renderFieldTitle = value => {
    if (Object.values(USER_TYPE).includes(value)) return USER_ROLE[value];
    return '--';
  };

  const renderFieldAdminName = value => {
    if (value) {
      return `${value.firstName} ${''} ${value.lastName}`;
    }
  };

  const renderStatus = row => {
    const {status, isFreeze} = row;
    switch (true) {
      case status === USER_STATUS.ACTIVE && !isFreeze:
        return <Chip label="Active" color={ColorType.success} />;
      case status === USER_STATUS.ACTIVE && !!isFreeze:
        return <Chip label="Frozen" color={ColorType.warning} />;
      case status === USER_STATUS.DELETED:
        return <Chip label="Deleted" color={ColorType.default} />;
      default:
        return '-';
    }
  };

  const getAdministrators = () => {
    setIsLoading(true);
    new AdministratorsService()
      .getAll(params)
      .then(res => {
        if (res?.data && Array.isArray(res.data.items)) {
          setDataSource(res.data.items);
          setTotalPage(res?.data?.total);
          setIsLoading(false);
        }
      })
      .catch(error => {
        setIsLoading(false);
        // Get api error => show notification or no items listing
        setError(error);
      });
  };

  const getAdminRoles = () => {
    const adminRolesQueryParams = {
      _page: 0,
      _size: 99999, // temp, check with be team if there is a value for all items
      status_eq: 1,
      _sort: 'id:asc',
    };
    new AccessRoleService().getAll(adminRolesQueryParams).then(res => {
      if (res?.data && Array.isArray(res.data.items)) {
        const isLoggedInUserSuperAdmin = accessRoleDepartments?.includes(
          rbacDepartments.SUPER_ADMIN
        );
        const items = res.data.items.reduce((acc: any, item: any) => {
          const isRoleItemSuperAdmin =
            item.roleKey === rbacDepartments.SUPER_ADMIN;
          if (isLoggedInUserSuperAdmin || !isRoleItemSuperAdmin) {
            acc.push({
              roleKey: item.roleKey,
              label: item.roleName,
              value: item.id,
            });
          }
          return acc;
        }, []);
        setAdminRoles(items);
      }
    });
  };

  const getMerchants = () => {
    new IslandPartnerService().getAll({_size: 99999}).then(res => {
      if (res.success) {
        if (!isEmpty(res.data) && !isEmpty(res.data.items)) {
          const listMerchant = res.data.items
            .map(item => ({
              ...item,
              label: item.name,
              value: item.name,
            }))
            .sort((a, b) => (a.label > b.label ? 1 : -1));
          setMerchants(listMerchant);
        }
      }
    });
  };

  const getExport = () => {
    setIsLoadingExport(true);
    new ExportExcelService()
      .exportEmailExcelSDCAdministrators({
        email: email,
        ...params,
      })
      .then(res => {
        setIsLoadingExport(false);
        if (res?.success) {
          showNotification({
            message: success.EXPORT_SUCCESS,
          });
        } else {
          showNotification({
            message: res?.errorMessage,
            variation: 'error',
          });
        }
      });
  };

  const handleFilter = () => {
    const updatedParams = {
      _page: 0,
      type_eq: valueFilter?.type_eq || undefined,
      roleName_contains: valueFilter?.roleName_contains || undefined,
      adminName_contains: valueFilter?.adminName_contains || undefined,
      email_contains: valueFilter?.email_contains || undefined,
      // phoneNumber_contains: valueFilter?.phoneNumber_contains || undefined,
      ipName_contains: valueFilter?.ipName_contains || undefined,
      isFreeze_eq: valueFilter?.isFreeze_eq || undefined,
    };
    setParams(preState => ({
      ...preState,
      ...updatedParams,
    }));
    toggleModalFilter();
    // handleClean();
  };

  const handleClean = () => {
    setValueFilter({
      email_contains: '',
      adminName_contains: '',
      ipName_contains: '',
      phoneNumber_contains: '',
      type_eq: '',
      roleName_contains: '',
      isFreeze_eq: '',
    });
  };

  const toggleModalFilter = () => {
    setIsModalFilter(!isModalFilter);
  };

  const deleteSearchParams = key => {
    if (searchParams.has(key)) {
      searchParams.delete(key);
      setSearchParams(searchParams);
    }
  };

  const handleDeleteChip = (type: string) => {
    if (type === 'adminName_contains') {
      deleteSearchParams('adminName_contains');
      setValueFilter({
        ...valueFilter,
        adminName_contains: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        adminName_contains: undefined,
      }));
    }

    if (type === 'ipName_contains') {
      deleteSearchParams('ipName_contains');
      setValueFilter({
        ...valueFilter,
        ipName_contains: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        ipName_contains: undefined,
      }));
    }

    if (type === 'email_contains') {
      deleteSearchParams('email_contains');
      setValueFilter({
        ...valueFilter,
        email_contains: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        email_contains: undefined,
      }));
    }

    if (type === 'phoneNumber_contains') {
      deleteSearchParams('phoneNumber_contains');
      setValueFilter({
        ...valueFilter,
        phoneNumber_contains: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        phoneNumber_contains: undefined,
      }));
    }

    if (type === 'type_eq') {
      deleteSearchParams('type_eq');
      setValueFilter({
        ...valueFilter,
        type_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        type_eq: undefined,
      }));
    }

    if (type === 'roleName_contains') {
      deleteSearchParams('roleName_contains');
      setValueFilter({
        ...valueFilter,
        roleName_contains: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        roleName_contains: undefined,
      }));
    }

    if (type === 'isFreeze_eq') {
      deleteSearchParams('isFreeze_eq');
      setValueFilter({
        ...valueFilter,
        isFreeze_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        isFreeze_eq: undefined,
      }));
    }
  };

  useEffect(() => {
    setSearchParams(
      queryString.stringify({
        ...params,
      })
    );
    getAdministrators();
  }, [params]);

  useEffect(() => {
    getMerchants();
    getAdminRoles();
  }, []);

  return (
    <React.Fragment>
      <ModalAddNew
        visible={isModalAddNew}
        onClose={() => toggleModal()}
        reloadPage={getAdministrators}
        adminRoles={adminRoles}
      />
      <Helmet title="Portal Users" />
      <Grid justifyContent="space-between" container spacing={6} columns={16}>
        <Grid item xs={8}>
          <Typography variant="h3" gutterBottom>
            Portal Users
          </Typography>

          <Breadcrumbs
            routes={[
              typeRoutes(
                'List of users with specific access, including Administrators with broad privileges and Island Partners limited to their assigned merchants',
                null,
                true
              ),
            ]}
          />
        </Grid>
        <Grid
          item
          xs={8}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {/* <ButtonExport
            params={params}
            exportMethod={new AdministratorsService().exportAdministrator}
            fileName="SDC_ADMINISTRATOR"
          /> */}
          <StyledStack direction="row" gap={3}>
            {searchParams.get('email_contains') !== null && (
              <Chip
                label={searchParams.get('email_contains')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('email_contains');
                }}
              />
            )}

            {searchParams.get('adminName_contains') !== null && (
              <Chip
                label={searchParams.get('adminName_contains')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('adminName_contains');
                }}
              />
            )}

            {searchParams.get('phoneNumber_contains') !== null && (
              <Chip
                label={searchParams.get('phoneNumber_contains')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('phoneNumber_contains');
                }}
              />
            )}

            {searchParams.get('type_eq') !== null && (
              <Chip
                label={
                  searchParams.get('type_eq') === '1'
                    ? 'Administrators'
                    : 'Merchants'
                }
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('type_eq');
                }}
              />
            )}

            {searchParams.get('roleName_contains') !== null && (
              <Chip
                label={searchParams.get('roleName_contains') as string}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('roleName_contains');
                }}
              />
            )}

            {searchParams.get('ipName_contains') !== null && (
              <Chip
                label={
                  merchants.find(item =>
                    item?.name
                      .toString()
                      .includes(searchParams.get('ipName_contains'))
                  )?.name
                }
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('ipName_contains');
                }}
              />
            )}

            {['true', 'false'].includes(
              searchParams.get('isFreeze_eq') as string
            ) && (
              <Chip
                label={
                  searchParams.get('isFreeze_eq') === 'true'
                    ? 'Frozen'
                    : 'Active'
                }
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('isFreeze_eq');
                }}
              />
            )}
          </StyledStack>
          {checkRbac(
            {
              permissionString: rbacPermissions.ADMINISTRATORS__LISTING__EXPORT,
            },
            <div
              style={{
                marginRight: '10px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                onClick={getExport}
                width="100px"
                variant="outlined"
                loading={isLoadingExport}
              >
                Export
              </Button>
            </div>
          )}
          {checkRbac(
            {
              permissionString: [
                rbacPermissions.ADMINISTRATORS__LISTING__CREATE_ADMINISTRATORS,
                rbacPermissions.ADMINISTRATORS__LISTING__CREATE_MERCHANTS,
              ],
            },
            <Button onClick={toggleModal} loading={isLoading}>
              Add new
            </Button>
          )}
          <Tooltips title="Filter list" sx={{marginLeft: '10px'}}>
            <IconButton
              aria-label="Filter list"
              size="large"
              onClick={toggleModalFilter}
            >
              <FilterListIcon />
            </IconButton>
          </Tooltips>
        </Grid>
      </Grid>

      <ModalFilter
        visible={isModalFilter}
        onClose={toggleModalFilter}
        handleFilter={handleFilter}
        handleClean={handleClean}
        valueFilter={valueFilter}
        defaultValueFilter={defaultValueFilter}
        setValueFilter={setValueFilter}
        deleteSearchParams={deleteSearchParams}
        merchants={merchants}
        adminRoles={adminRoles}
      />

      <Divider my={6} />

      <Table
        dataSource={dataSource}
        columns={columns}
        page={params._page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        rowsPerPage={params._size}
        textNodata="There are no portal user(s) matching the filter."
        order={order}
        orderBy={orderBy}
        dense={dense}
        isMultiCheckbox={false}
        count={totalPage}
        isLoading={isLoading}
      >
        {!error && (
          <TableBody>
            {dataSource?.map(row => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.id}
                  onMouseEnter={() => setFocusId(row.id)}
                  onMouseLeave={() => setFocusId(null)}
                >
                  <TableCell>{row.id}</TableCell>
                  <TableCell align="left">
                    {renderFieldAdminName(row)}
                  </TableCell>
                  <TableCell align="left">{row?.email}</TableCell>
                  <TableCell align="left">
                    {renderFieldTitle(row.type)}{' '}
                  </TableCell>
                  <TableCell align="left">
                    {row?.islandPartnerName || '-'}
                  </TableCell>
                  <TableCell align="left">{row?.roleName ?? '-'}</TableCell>
                  <TableCell align="left">
                    {formatLocalDateFromUTCTime(
                      row.lastLogin,
                      formatDateTimes
                    ) ?? '-'}
                  </TableCell>
                  <TableCell align="left">{renderStatus(row)}</TableCell>

                  <TableCell
                    align="right"
                    padding="checkbox"
                    style={{paddingRight: '10px'}}
                  >
                    {renderAction(row.id)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
    </React.Fragment>
  );
}

export default SDCAdministrators;
